import React from "react";

import img_banker_win from "@/assets/img/baccarat_win/banker_win.gif";
import img_player_win from "@/assets/img/baccarat_win/player_win.gif";

import img_dragon_win from "@/assets/img/baccarat_win/dragon_win.gif";
import img_tiger_win from "@/assets/img/baccarat_win/tiger_win.gif";

import img_tian_win from "@/assets/img/shiofights_win/tian_win.gif";
import img_di_win from "@/assets/img/shiofights_win/di_win.gif";

import img_tie from "@/assets/img/baccarat_win/tie.gif";

import FlippingCard from "../FlippingCard";

//Todo: move all CSS class of baccarat-result to the same folder

import "./index.scss";

import { IGameType } from "@/types/GlobalTypes";
import { getDragonVal, getTigerVal } from "@/modules/games/DragonTiger";
import { getBasePcode } from "@/modules/gamePcode";

interface IProps {
	activeGame: IGameType;

	result?: { win: string };

	virtualCardScanResult: any; //Todo: Define this to maintain consistency
}

interface IState {
	playerWinAnimation: JSX.Element;
	bankerWinAnimation: JSX.Element;

	dragonWinAnimation: JSX.Element;
	tigerWinAnimation: JSX.Element;
	
	tianWinAnimation: JSX.Element;
	diWinAnimation: JSX.Element;
	
	tieAnimation: JSX.Element;
}

//Todo: make this reusable in mobile
export default class VirtualCards extends React.Component<IProps, IState> {
	playerCards: JSX.Element[];
	bankerCards: JSX.Element[];

	dragonValue: number;
	tigerValue: number;

	constructor(props) {
		super(props);

		this.state = {
			// gifBankerWin: img_banker_win,
			// gifPlayerWin: img_player_win,
			// gifTie: img_tie,

			// Baccarat
			playerWinAnimation: <img src={img_player_win + "?a=" + Math.random()} alt="Player Win" />,
			bankerWinAnimation: <img src={img_banker_win + "?a=" + Math.random()} alt="Banker Win" />,

			// Dragon Tiger
			dragonWinAnimation: <img src={img_dragon_win + "?a=" + Math.random()} alt="Player Win" />,
			tigerWinAnimation: <img src={img_tiger_win + "?a=" + Math.random()} alt="Banker Win" />,

			// Shio Fights
			tianWinAnimation: <img src={img_tian_win + "?a=" + Math.random()} alt="Tian Win" />,
			diWinAnimation: <img src={img_di_win + "?a=" + Math.random()} alt="Di Win" />,

			// Generic Tie Animation
			tieAnimation: <img src={img_tie + "?a=" + Math.random()} alt="Tie" />,
		};
	}

	componentDidUpdate(prevProps: IProps) {
		if (this.props.result && prevProps.result) {
			if (this.props.result.win !== prevProps.result.win) {
				switch (this.props.result.win) {
					case "tie":
						this.setState({
							tieAnimation: <img src={img_tie + "?a=" + Math.random()} alt="Tie" />
						});
						break;

					// Baccarat
					case "player":
						this.setState({
							playerWinAnimation: <img src={img_player_win + "?a=" + Math.random()} alt="Player Win" />
						});
						break;
					case "banker":
						this.setState({
							bankerWinAnimation: <img src={img_banker_win + "?a=" + Math.random()} alt="Banker Win" />
						});
						break;

					// Dragon & Tiger
					case "dragon":
						this.setState({
							dragonWinAnimation: <img src={img_dragon_win + "?a=" + Math.random()} alt="Dragon Win" />
						});
						break;
					case "tiger":
						this.setState({
							tigerWinAnimation: <img src={img_tiger_win + "?a=" + Math.random()} alt="Tiger Win" />
						});
						break;

					//Shio Fights
					case "tian":
						this.setState({
							tianWinAnimation: <img src={img_tian_win + "?a=" + Math.random()} alt="Tian" />
						});
						break;
					case "di":
						this.setState({
							diWinAnimation: <img src={img_di_win + "?a=" + Math.random()} alt="Di" />
						});
						break;

					default: break;
				}
			}
		}
	}

	processBaccaratRender(scanResult: { player: string; banker: string; }) {
		this.playerCards = [];
		this.bankerCards = [];

		//Temporary array variable to contain the split content
		// "Jh-Qd-9s" to ["Jh", "Qd", "9s"]
		let temp: string[];

		//Fills left card set with images
		if (scanResult && scanResult.player) {
			temp = scanResult.player.split("-").reverse();
			this.playerCards = temp.map((item, idx) =>
				<FlippingCard
					key={"pc" + idx}
					lie={idx === 0}
					active={item !== "x"}
					cardImage={item}
				/>
			);
		}

		//Fills right cards with images
		if (scanResult && scanResult.banker) {
			temp = scanResult.banker.split("-");
			this.bankerCards = [1, 0, 2].map(
				(item, idx) =>
					item === 2 ?
						<FlippingCard
							key={"bc2"}
							lie={true}
							active={temp[item] !== "x"}
							cardImage={temp[item]}
						/>
						: <FlippingCard
							key={`bc${idx}`}
							active={temp[item] !== "x"}
							cardImage={temp[item]}
						/>
			);
		}
	}

	processDragonTigerRender(scanResult: {dragon: string, tiger: string}) {
		//Evaluates DT values
		this.dragonValue = 0;
		this.tigerValue = 0;

		if (scanResult && scanResult.dragon && scanResult.tiger) {
			this.dragonValue = getDragonVal(scanResult);
			this.tigerValue = getTigerVal(scanResult);
		}
	}

	renderBaccarat(scanResult) {
		const basePcode = getBasePcode(this.props.activeGame.pcode);

		return (
			<div className={
				"overlay virtual-cards " + basePcode +
				(scanResult.player === "x-x-x" ? " hidden" : "") +
				(this.props.activeGame.maximised && scanResult.win === "" ? " transparent" : "")
			}>
				{
					scanResult.win === "player"
						? [
							<div key="letter" className="left-letter win">
								{this.state.playerWinAnimation}
							</div>,
							<div key="value" className="left-value win">{scanResult.playerValue}</div>
						] : [
							<div key="letter" className="left-letter">P</div>,
							<div key="value" className="left-value">{scanResult.playerValue}</div>
						]
				}

				{
					scanResult.win === "banker"
						? [
							<div key="letter" className="right-value win">
								{scanResult.bankerValue}
							</div>,
							<div key="value" className="right-letter win">
								{this.state.bankerWinAnimation}
							</div>
						] : [
							<div key="letter" className="right-value">
								{scanResult.bankerValue}
							</div>,
							<div key="value" className="right-letter">B</div>
						]
				}

				<div className="left cards">
					{this.playerCards}
				</div>

				<div className="right cards">
					{this.bankerCards}
				</div>

				<div className="tie-container">
					{
						scanResult.win === "tie"
							? this.state.tieAnimation
							: null
					}
				</div>
			</div>
		);
	}

	renderDragonTiger(scanResult) {
		const basePcode = getBasePcode(this.props.activeGame.pcode);

		return (
			<div className={
				"overlay virtual-cards " + basePcode +
				(scanResult.dragon === "x" ? " hidden" : "") +
				(this.props.activeGame.maximised && scanResult.win === "" ? " transparent" : "")
			}>
				{
					scanResult.win === "dragon"
						? [
							<div key="letter" className="left-letter win">
								{this.state.dragonWinAnimation}
							</div>,
							<div key="value" className="left-value win">
								{this.dragonValue}
							</div>
						] : [
							<div key="letter" className="left-letter dragon">
								D
							</div>,
							<div key="value" className="left-value">
								{this.dragonValue}
							</div>
						]
				}

				{
					scanResult.win === "tiger"
						? [
							<div key="letter" className="right-value win">
								{this.tigerValue}
							</div>,
							<div key="value" className="right-letter win">
								{this.state.tigerWinAnimation}
							</div>
						] : [
							<div key="letter" className="right-value">
								{this.tigerValue}
							</div>,
							<div key="value" className="right-letter tiger">
								T
							</div>
						]
				}

				<div className="tie-container">
					{
						scanResult.win === "tie"
							? this.state.tieAnimation
							: null
					}
				</div>

				<div className="left cards">
					{
						scanResult.dragon &&
						scanResult.dragon.split("-").map((item, idx) =>
							idx === 2 ?
								<FlippingCard
									key={"dc2"}
									lie={true}
									active={item !== "x"}
									cardImage={item}
								/>
								:
								<FlippingCard
									key={`dc${idx}`}
									active={item !== "x"}
									cardImage={item}
								/>
						)
					}
				</div>

				<div className="right cards">
					{
						scanResult.tiger &&
						scanResult.tiger.split("-").map((item, idx) =>
							idx === 2 ?
								<FlippingCard
									key={`tc2`}
									lie={true}
									active={item !== "x"}
									cardImage={item}
								/>
								:
								<FlippingCard
									key={`tc${idx}`}
									active={item !== "x"}
									cardImage={item}
								/>
						)
					}
				</div>
			</div>
		);
	}

	renderShioFights(scanResult) {
		const basePcode = getBasePcode(this.props.activeGame.pcode);

		return (
			scanResult.di !== "x" ?
				<div className={
					"overlay virtual-cards " + basePcode
				}>

					{
						scanResult.win === "di" ? [
							<div key="letter" className="left-letter win">
								{this.state.diWinAnimation}
							</div>,
							null
						] : [
								<div key="letter" className="left-letter dragon">
									<span>Dì</span>
								</div>,
								null
							]
					}

					{
						scanResult.win === "tian" ? [
							<div key="letter" className="right-letter win">
								{this.state.tianWinAnimation}
							</div>, null
						] : [
								<div key="letter" className="right-letter tiger">
									<span>Tiān</span>
								</div>,
								null
							]
					}

					<div className="tie-container">
						{
							scanResult.win === "tie"
								? this.state.tieAnimation
								: null
						}
					</div>


					<div className="left cards">
						<FlippingCard
							pathkey="m27"
							active={scanResult.di !== "x"}
							cardImage={scanResult.di}
						/>
					</div>

					<div className="right cards">
						<FlippingCard
							pathkey="m27"
							active={scanResult.tian !== "x"}
							cardImage={scanResult.tian}
						/>
					</div>
				</div>
				: null
		);
	}

	render() {
		const scanResult = this.props.virtualCardScanResult;
		const basePcode = getBasePcode(this.props.activeGame.pcode);

		//Card scan 'result'
		if (!scanResult)
			return null;

		switch (basePcode) {
			case "m22":
			case "m28":
			case "m38":
				this.processBaccaratRender(scanResult);
				break;

			case "m23":
				this.processDragonTigerRender(scanResult);
				break;
			default: break;
		}

		return (
			basePcode === "m22" || basePcode === "m28" || basePcode === "m38" ? (
				this.renderBaccarat(scanResult)
			) : basePcode === "m23" ? (
				this.renderDragonTiger(scanResult)
			) : basePcode === "m27" ? (
				this.renderShioFights(scanResult)
			) : null
		);
	}
}